import React, { FC } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Stack, Button, Typography } from '@mui/material';

import { Input } from '../../../components/Input';
import { PatchesName } from '../../../helpers/types';
import { IS_REQUIRED } from '../../../helpers/constants';
import { CustomModal } from '../../../components/CustomModal';
import { setProjectName } from '../../../graphql/store/functionsWitingCache';

interface Props {
  closeModal(): void;
  handlerAddProject(): void;
}

const initialValues = {
  project: '',
};

const validationSchema = yup.object({
  project: yup.string().required(IS_REQUIRED),
});

export const AddProjectModal: FC<Props> = ({ closeModal, handlerAddProject }) => {
  const navigate = useNavigate();

  const { values, handleChange, handleSubmit, touched, errors } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      if (values.project) {
        setProjectName({
          dataWrite: {
            nameProject: values.project,
          },
        });
        navigate(`/${PatchesName.Home}`);
      }
    },
  });

  return (
    <CustomModal title="Впишите название проекта" handleClose={closeModal} open={true}>
      <Stack
        display="flex"
        component="form"
        alignItems="center"
        flexDirection="column"
        onSubmit={handleSubmit}
      >
        <Input
          width="150%"
          name="project"
          value={values.project}
          onChange={handleChange}
          error={touched.project && !!errors.project}
          helperText={touched.project && errors.project}
        />
        <Button
          type="submit"
          onClick={handlerAddProject}
          variant="contained"
          style={{
            width: '80%',
            height: '95%',
            marginTop: 40,
            backgroundColor: '#567CF0',
          }}
        >
          <Typography>Создать проект</Typography>
        </Button>
      </Stack>
    </CustomModal>
  );
};
